import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-basic-table',
    templateUrl: './basic-table.component.html',
    styleUrls: ['./basic-table.component.scss'],
    standalone: false
})
export class BasicTableComponent {
  @Input() headers;
  @Input() data;
}
